import { Component, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, RiderService } from 'app/services';
import { Utils } from 'app/utils';
import moment from 'moment';
import { PaymentProcessingService } from 'app/services/payment-processing.service';
import { BetaFeature } from 'app/models';

@Component({
    selector: 'driver-campaign-xpress50-reward',
    templateUrl: './driver-campaign-xpress50-reward.component.html',
    styleUrls: ['./driver-campaign-xpress50-reward.component.scss'
    ]
})
export class DriverCampaignXpress50RewardComponent implements OnInit {
    @Input()
    public showDialog: boolean = false;

    @Input()
    public onHide: () => void = () => { };

    public selectedDate: any = new Date();

    public cancel() {
        this.onHide();
    }

    public onChangeDate() {
        this.getRidersForReward();
    }

    public riders: any;
    public totalRecords: number = 0;
    public loading: boolean = false;
    public showErrorDialog: boolean = false;
    public failedRiders: any = [];
    public hasAccessToReward: boolean = false;

    public cols = [
        {
            field: 'RiderId', header: 'Driver ID', width: '20%', model: 'RiderId'
        },
        {
            field: 'FirstName', header: 'First Name', width: '20%', model: 'FirstName'
        },
        {
            field: 'LastName', header: 'Last Name', width: '20%', model: 'LastName'
        },
        {
            field: 'Phone', header: 'Phone', width: '20%', model: 'Phone'
        },
        {
            field: 'AcceptanceRate', header: 'Accep. Rate', width: '20%', model: 'AcceptanceRate'
        },
        {
            field: 'CancellationRate', header: 'CXL Rate', width: '20%', model: 'CancellationRate'
        },
        {
            field: 'CompleteRate', header: 'Compl. Rate', width: '20%', model: 'CompleteRate'
        },
        {
            field: 'CountTrips', header: 'No of Trips', width: '20%', model: 'CountTrips'
        },
        {
            field: 'TotalActivity', header: 'Online Hours', width: '20%', model: 'TotalActivity'
        },
        {
            field: 'XpressEarningAmount', header: 'Xpress Earnings', width: '20%', model: 'XpressEarningAmount'
        },
        {
            field: 'IsForReward', header: 'Payout', width: '20%', model: 'IsForReward'
        }
    ];

    constructor(
        private messageService: MessageService,
        private riderService: RiderService,
        private paymentProcessingService: PaymentProcessingService,
        private appDataService: AppDataService) {
            this.hasAccessToReward = this.checkRewardBetaFeatures();
    }
    ngOnInit(): void {
        this.getRidersForReward();
    }

    public getRidersForReward() {
        const dto = {
            Date: moment(this.selectedDate).format('YYYY-MM-DD'),
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.riderService.getXpress50Riders4wForReward(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riders = data.Items;
                this.totalRecords = data.TotalRecords;
            });

    }

    public getRidersForRewardCount(): number {
        return this.riders?.filter((rider: any) => rider.IsForReward === true).length;
    }

    public rewardRxp4w50Drivers() {
        if (!this.hasAccessToReward) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No access for reward' });
            return;
        }
        const riderIds = this.riders
            .filter((rider: any) => rider.IsForReward === true)
            .map((rider: any) => rider.RiderId);

        const dto = {
            XpressRiderIds: riderIds
        };

        this.loading = true;
        this.paymentProcessingService.reward4wXpress50Riders(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Riders are rewarded' });
                this.loading = false;
                if (data.FailedRiders.length === 0) {
                    this.cancel();
                }
                else {
                    this.failedRiders = data.FailedRiders;
                    this.showErrorDialog = true;
                }
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleHideErrorDialog() {
        this.showErrorDialog = false;
        this.failedRiders = [];
    }

    checkRewardBetaFeatures(): boolean {
        return this.appDataService.authData.BetaFeatures.includes(BetaFeature.Reward4wRxpRider);
    }
}
